import * as React from 'react';
import FlipMove from 'react-flip-move';
import type { Camera, NearbyCamerasProps } from './Cameras.types';
import CameraWrapper from './CameraWrapper';

export class NearbyCameras extends React.Component<NearbyCamerasProps> {
    constructor(props: NearbyCamerasProps) {
        super(props);
    }

    public render(): JSX.Element {
        if (this.props.cameras.length === 0) {
            return null;
        }

        const CustomTag = this.props.animateTiles ? FlipMove : 'div';

        return <CustomTag className="nearby-cameras row">{this.props.cameras.map(this.renderItem.bind(this))}</CustomTag>;
    }

    private renderItem(item: Camera): JSX.Element {
        return <CameraWrapper key={item.pageId} {...this.props} {...item} className="col-12 col-sm-6 col-lg-4 mb-4" url={item.url} />;
    }
}
